import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import apolloProvider, { apolloClient } from './apollo/vue-apollo'
import config from './config'
global.config = config;
import './styles/quasar.styl'
import lang from 'quasar/lang/en-gb.js'
// import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import '@quasar/extras/material-symbols-outlined/material-symbols-outlined.css'


import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faUserSecret, faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'



import {
  QEditor,
  QMarkupTable,
  QLinearProgress,
  QScrollObserver,
  Quasar,
  QFab,
  QFabAction,
  QToggle,
  QScrollArea,
  QAvatar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QBar,
  QBtnDropdown,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QSpace,
  QCard,
  QCardActions,
  QImg,
  QCardSection,
  QDialog,
  QRange,
  QBadge,
  QInput,
  QBreadcrumbs,
  QBreadcrumbsEl,
  ClosePopup,
  QCarousel,
  QCarouselControl,
  QCarouselSlide,
  QTable,
  QTd,
  QTh,
  QTr,
  QMenu,
  QPopupProxy,
  QTabs,
  QTab,
  QTabPanels,
  QTabPanel,
  QCheckbox,
  QSeparator,
  QSlideTransition,
  QExpansionItem,
  QPageSticky,
  QPopupEdit,
  Dialog,
  Loading,
  Ripple,
  QDate,
  QTime,
  Notify,
  QPagination,
  QSpinnerIos,
  QSpinnerDots,
  QSpinner,
  QSpinnerGears,
  QSelect,
  QTooltip,
  QInfiniteScroll,
  QUploader,
  QBanner,
  QStepper,
  QStep,
  QStepperNavigation,
  QField,
  QInnerLoading,
  QForm,
  LoadingBar,
  QFooter,
  QRadio,
  QUploaderAddTrigger,
  QOptionGroup,
  QColor,
  QSlider,
  QVideo,
  QBtnToggle,
  QSplitter
} from 'quasar'
import initServiceWorkerUpdates from '@/util/serviceWorkerUpdates'
import inactivityDetector from '@/util/inactivityDetector'

Vue.use(Quasar, {
  config: {},
  components: {
    QEditor,
    QBtnToggle,
    QVideo,
    QCarouselControl,
    QSlider,
    QMarkupTable,
    QColor,
    QLinearProgress,
    QOptionGroup,
    QUploaderAddTrigger,
    QAvatar,
    QFab,
    QFabAction,
    QToggle,
    QScrollArea,
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QBar,
    QBtnDropdown,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QSpace,
    QCard,
    QCardActions,
    QImg,
    QCardSection,
    QDialog,
    QRange,
    QBadge,
    QInput,
    QBreadcrumbs,
    QBreadcrumbsEl,
    QCarousel,
    QCarouselSlide,
    QTable,
    QTd,
    QTh,
    QTr,
    QMenu,
    QPopupProxy,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QCheckbox,
    QSeparator,
    QExpansionItem,
    QPageSticky,
    QPopupEdit,
    QDate,
    QTime,
    QPagination,
    QSpinnerIos,
    QSpinnerDots,
    QSpinner,
    QSpinnerGears,
    QSlideTransition,
    QSelect,
    QTooltip,
    QInfiniteScroll,
    QUploader,
    QBanner,
    QStepper,
    QStep,
    QStepperNavigation,
    QField,
    QInnerLoading,
    QForm,
    QFooter,
    QRadio,
    QScrollObserver,
    QSplitter
  },
  directives: {
    ClosePopup,
    Ripple
  },
  plugins: {
    Dialog,
    Notify,
    Loading,
    LoadingBar
  },
  lang: lang
})

library.add(faUserSecret,faBars,faFacebookF,faInstagram,faLinkedinIn,faEnvelope)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false;
// Vue.config.devtools = true;

const app = new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')

store.$app = app
store.$apollo = apolloClient

// Do any async store initialisation
store.dispatch('auth/init').then(() => {
  store.dispatch('cart/init')
  return store.dispatch('filters/fetchProductColours')
})

// noinspection JSIgnoredPromiseFromCall

window.vuexStore = store

// Reload the page after 30 minutes of inactivity so that users always
// have the latest versions of objects from the backend (eg. products, cart, etc.).
inactivityDetector(() => {
  window.location.reload()
}, 60 * 30) // 30 minutes

initServiceWorkerUpdates(app.$q)
